<div #container class="relative">
  @if (label || canCreateNew) {
    <div class="flex items-center justify-between mb-1.5">
      @if (label) {
        <div class="flex items-center gap-2">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">{{ label }}</label>
          @if (autoFilled) {
            <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium bg-success-100 text-success-700 dark:bg-success-500/20 dark:text-success-400 animate-pulse">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              Auto-completado
            </span>
          }
        </div>
      } @else { <span></span> }
      @if (canCreateNew) {
        <button type="button" (click)="onCreateNew()"
          [title]="createNewLabel"
          class="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-brand-600 hover:text-brand-700 hover:bg-brand-50 dark:text-brand-400 dark:hover:text-brand-300 dark:hover:bg-brand-500/10 rounded-md transition-colors">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          {{ createNewLabel }}
        </button>
      }
    </div>
  }

  @if (mode === 'single' && selectedId != null) {
    <div class="flex items-center justify-between gap-2 px-3 py-2 rounded-lg border bg-brand-50 dark:bg-brand-900/20 transition-all"
      [class.border-success-400]="autoFilled"
      [class.bg-success-50]="autoFilled"
      [class.dark:bg-success-500/10]="autoFilled"
      [class.border-brand-200]="!autoFilled"
      [class.dark:border-brand-800]="!autoFilled">
      <div class="min-w-0 flex-1">
        <div class="text-sm font-medium text-gray-800 dark:text-gray-100 truncate">{{ selectedLabel }}</div>
        @if (selectedSublabel) {
          <div class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ selectedSublabel }}</div>
        }
      </div>
      @if (!readonlySelection) {
        <button type="button" (click)="clear()"
          class="p-1 rounded-md text-gray-400 hover:text-error-600 hover:bg-error-50 dark:hover:bg-error-900/20"
          title="Quitar">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      }
    </div>
  } @else {
    <div class="relative">
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (input)="onInput()"
        (keydown.enter)="onEnter($event)"
        (focus)="onFocus()"
        [placeholder]="placeholder"
        autocomplete="off"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent pl-9 pr-3 py-2.5 text-sm placeholder:text-gray-400 focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"/>
      <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
        fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      @if (loading) {
        <span class="absolute right-3 top-1/2 -translate-y-1/2 inline-block w-4 h-4 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></span>
      }
    </div>

    @if (open) {
      <div class="absolute z-30 mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg max-h-60 overflow-y-auto"
        (scroll)="onScroll($event)">
        @if (results.length === 0 && !loading) {
          <div class="px-3 py-3 text-sm text-gray-500 dark:text-gray-400 flex items-center justify-between gap-3">
            <span>Sin resultados.</span>
            @if (canCreateNew) {
              <button type="button" (mousedown)="onCreateNew()"
                class="text-xs font-medium text-brand-600 hover:underline">
                + {{ createNewLabel }}
              </button>
            }
          </div>
        }
        @for (r of results; track r.id) {
          <button type="button" (mousedown)="pick(r)"
            class="w-full text-left px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700/60 transition-colors border-b border-gray-100 dark:border-gray-700 last:border-b-0">
            <div class="text-sm font-medium text-gray-800 dark:text-gray-100">{{ r.label }}</div>
            @if (r.sublabel) {
              <div class="text-xs text-gray-500 dark:text-gray-400">{{ r.sublabel }}</div>
            }
          </button>
        }
        @if (loadingMore) {
          <div class="flex justify-center items-center py-2">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
            <span class="ml-2 text-xs text-gray-400 dark:text-gray-500">Cargando más...</span>
          </div>
        }
      </div>
    }
  }

  @if (helperText) {
    <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ helperText }}</p>
  }
</div>
